import React from "react";
import { APP_PREFIX_PATH } from "configs/AppConfig";

export const attendanceRoutes = [
	{
		key: "attendance-log",
		exact: true,
		path: `${APP_PREFIX_PATH}/attendance/log`,
		component: React.lazy(() => import("views/app-views/attendance/pages/AttendanceLog")),
	},
	{
		key: "attendance-summary",
		exact: true,
		path: `${APP_PREFIX_PATH}/attendance/summary`,
		component: React.lazy(() => import("views/app-views/attendance/pages/AttendanceSummary")),
	},
];
